import moment from 'moment-timezone';

export const defaultRange = () => ({
  delivered_or_cancelled_at_from: moment().subtract(2, 'months').format('YYYY-MM-DD'),
  delivered_or_cancelled_at_to: moment().format('YYYY-MM-DD'),
});

const getRangeFilter = (range, dateField) => {
  if (!['delivered_or_cancelled_at'].includes(dateField)) {
    return {};
  }

  if (!range) {
    return defaultRange();
  }

  const { from, to } = range;

  if (!from || !to) {
    return defaultRange();
  }

  return {
    delivered_or_cancelled_at_from: moment(from).format('YYYY-MM-DD'),
    delivered_or_cancelled_at_to: moment(to).format('YYYY-MM-DD'),
  };
};

export default getRangeFilter;
